module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"labelPlaceholder":"Filter by label","datePlaceholder":"Filter by dates","labelNotFound":"Label not found"},"de":{"labelPlaceholder":"Filter nach Label","datePlaceholder":"Filter nach Zeitraum","labelNotFound":"Label-Name nicht gefunden"}}')
  delete Component.options._Ctor
}
